import React from 'react';
import { Typography, Box, Chip, Divider } from '@mui/material';
import {UNIT_LABELS_SINGULAR, UNIT_LABELS_PLURAL} from '../utils/units.js';
// Add these constants at the top of the file
// const UNIT_LABELS_SINGULAR = {
//   'unidad': 'unidad',
//   'kg': 'kg',
//   'lt': 'litro',
//   'm2': 'metro cuadrado',
//   'mt': 'metro',
//   'cm': 'centímetro',
//   'docena': 'docena',
//   'caja': 'caja',
//   'pack': 'pack',
//   'hectarea': 'hectárea'
// };

// const UNIT_LABELS_PLURAL = {
//   'unidad': 'unidades',
//   'kg': 'kilogramos',
//   'lt': 'litros',
//   'm2': 'metros cuadrados',
//   'mt': 'metros',
//   'cm': 'centímetros',
//   'docena': 'docenas',
//   'caja': 'cajas',
//   'pack': 'packs',
//   'hectarea': 'hectáreas'
// };
// Update the PriceDisplay component
const PriceDisplay = ({ basePrice, priceBreaks, hidePrice, unit,hasMainPrice }) =>
  {
    if (hidePrice)
    {
      return <Typography variant="subtitle1" color="text.secondary">Consultar precio</Typography>;
    }
  
    // Get the lowest price from the last price break, if it exists and is lower than base price
    const lowestPriceBreak = priceBreaks?.length > 0 ? priceBreaks[priceBreaks.length - 1] : null;
    const displayPrice = lowestPriceBreak && lowestPriceBreak.price < basePrice
      ? { price: lowestPriceBreak.price, quantity: lowestPriceBreak.minQuantity }
      : { price: basePrice, quantity: null };
  
    return (
      <Box>
        {hasMainPrice && <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#424242' }}>
          ${displayPrice.price.toLocaleString()} por {unit}
          {displayPrice.quantity && (
            <Box component="span" sx={{
              fontSize: '0.8em',
              color: 'success.main',
              ml: 1
            }}>
              <br></br>({displayPrice.quantity}+ {UNIT_LABELS_PLURAL[unit]})
            </Box>
          )}
        </Typography>}
        {priceBreaks?.length > 0 && (
          <Box sx={{ mt: 0.5 }}>
            <Divider sx={{ my: 0.5 }} />
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
              Otros precios por volumen:
            </Typography>
            <Box sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1,
              mt: 0.5
            }}>
              {priceBreaks
                .slice(0, -1) // Exclude the last price break if it's being shown as main price
                .map((break_, index) => (
                  <Chip
                    key={index}
                    size="small"
                    label={`${break_.minQuantity}+ ${UNIT_LABELS_PLURAL[unit] ? UNIT_LABELS_PLURAL[unit] : "unidades"}: $${break_.price.toLocaleString()} por ${unit ? unit : "unidad"}`}
                    sx={{
                      backgroundColor: 'rgba(29, 63, 85, 0.55)',
                      borderRadius: '2px',
                      color: 'white',
                      py:1,
                      fontWeight: 600,
                      fontSize: '0.8rem'
                    }}
                  />
                ))}
            </Box>
          </Box>
        )}
      </Box>
    );
  };

export default PriceDisplay; 